import { useEffect, useState } from 'react';
import axios from 'axios';
import Menu from '@mui/material/Menu';
import { Formik, Form } from 'formik';
import { IconButton, TextField, Typography, Button, Stack, Box, MenuItem } from '@mui/material';
import Iconify from './Iconify';
import { CustomButton } from '../theme/CustomButton';

const Filter = ({ toggleFilter, applyFilters }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [categoryData, setCategoryData] = useState(null);
  useEffect(() => {
    getcategories();
  }, []);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const getcategories = async (options) => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/category/designation/all`, {
        params: {
          size: 100,
        },
      });
      console.log('category', res);
      setCategoryData(res.data.data.categories);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div>
        <Box style={{ display: 'flex', justifyContent: 'end' }}>
          <IconButton onClick={handleClick}>
            <Iconify icon="ic:round-filter-list" />
            <Typography variant="h6"> Filter</Typography>
          </IconButton>

          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
          >
            <Formik
              initialValues={{
                resumeId: '',
                status: '',
                fullname: '',
                email: '',
                designation: '',
                startDate: '',
                endDate: '',
              }}
              onSubmit={async (values) => {
                applyFilters(values);
              }}
            >
              {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
                <Form style={{ padding: '10px' }}>
                  <Stack
                    spacing={1.5}
                    direction="column"
                    sx={{ minWidth: { lg: '400px', md: '400px', sm: '400px', xl: '400px' } }}
                  >
                    <Stack spacing={1} direction={{ lg: 'row', xl: 'row', md: 'row', sm: 'row', xs: 'column' }}>
                      <TextField
                        fullWidth
                        id="resumeId"
                        name="resumeId"
                        label="Resume ID"
                        value={values.resumeId}
                        onChange={handleChange}
                      />
                      <TextField
                        fullWidth
                        id="status"
                        name="status"
                        label="Resume Status"
                        select
                        value={values.status}
                        onChange={handleChange}
                      >
                        <MenuItem value="AWAITING_REVIEW">AWAITING REVIEW</MenuItem>
                        <MenuItem value="REVIEWED">REVIEWED</MenuItem>
                        <MenuItem value="CONTACTING">CONTACTING</MenuItem>
                        <MenuItem value="REJECTED">REJECTED</MenuItem>
                        <MenuItem value="HIRED">HIRED</MenuItem>
                      </TextField>
                    </Stack>
                    <Stack spacing={1} direction={{ lg: 'row', xl: 'row', md: 'row', sm: 'row', xs: 'column' }}>
                      <TextField
                        fullWidth
                        id="fullname"
                        name="fullname"
                        label="Fullname"
                        value={values.fullname}
                        onChange={handleChange}
                      />
                      <TextField
                        fullWidth
                        id="email"
                        name="email"
                        label="Email"
                        value={values.email}
                        onChange={handleChange}
                      />
                    </Stack>
                    <Stack direction={'row'} spacing={2} alignItems="center">
                      <TextField
                        fullWidth
                        id="designation"
                        name="designation"
                        label="Resume designation"
                        select
                        value={values.designation}
                        onChange={handleChange}
                      >
                        {categoryData?.map((data, index) => (
                          <MenuItem value={data._id}>{data.name}</MenuItem>
                        ))}
                      </TextField>
                    </Stack>
                    <Stack direction={'row'} spacing={2} alignItems="center">
                      <TextField
                        type="date"
                        name="startDate"
                        label="Start Date"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        value={values.startDate}
                        onChange={handleChange}
                      />
                      <p style={{ paddingTop: '15px' }}>to</p>
                      <TextField
                        type="date"
                        name="endDate"
                        fullWidth
                        label="End Date"
                        InputLabelProps={{ shrink: true }}
                        value={values.endDate}
                        onChange={handleChange}
                      />
                    </Stack>

                    <CustomButton variant="contained" type="submit" style={{ marginTop: '10px' }}>
                      Filter
                    </CustomButton>
                  </Stack>
                </Form>
              )}
            </Formik>
          </Menu>
        </Box>
      </div>
    </>
  );
};

export default Filter;
